import { Card } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const CardTotalVisitors = props => {
  const { t } = useTranslation(['cookies']);
  return (
    <Card
      sx={{
        padding: '8px',
        textAlign: 'center',
        boxShadow: 'none',
        border: '1px solid #ccc',
      }}
    >
      <span style={{ fontSize: '14px', color: '#6b7280' }}>{t('cookies:show.totalVisitors.label')}</span>
      <br />
      <span style={{ fontSize: '32px', fontWeight: 'bold', marginBlockStart: '8px' }}>{props.totalVisitors}</span>
    </Card>
  );
};
